import React from "react";
import { Card } from "primereact/card";
import { useQuery } from "@tanstack/react-query";
import { ProgressSpinner } from "primereact/progressspinner";
import adminService from "../../services/admin/admin.services";
import { ResponseCounts } from "../../services/forms/form.dto";

const SurveyResults = () => {
  const { data: surveyResults, isLoading: surveyResponseLoading } = useQuery({
    queryKey: ["surveyResults"],
    queryFn: async () => await adminService.GetSurveyResults()
  });

  if (surveyResponseLoading) {
    return (
      <div className="flex justify-content-center">
        <ProgressSpinner />
      </div>
    );
  } else {
    console.log(surveyResults);
  }

  const renderResponseCounts = (counts: ResponseCounts) => {
    const formatTestName = (name: string) => {
      // Test isimlerini insan dostu bir formata çevirir
      return name
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    return (
      <div className="grid">
        {Object.entries(counts).map(([response, count]) => (
          <div key={response} className="col-12 md:col-4 lg:col-3">
            <div className="p-2 border-1 surface-border border-round shadow-2">
              <div className="text-lg font-bold text-primary">{formatTestName(response)}</div>
              <div className="mt-2 text-lg">
                <strong>Sayı:</strong> {count}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };
  const renderResponseCountsAnaliz = (counts: ResponseCounts) => {
    const formatTestName = (name: string) => {
      // Test isimlerini insan dostu bir formata çevirir
      return name
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    return (
      <div className="grid">
        {Object.entries(counts).map(([response, count]) => (
          <div key={response} className="col-12">
            <div className="p-2 border-1 surface-border border-round shadow-2">
              <div className="text-lg font-bold text-primary">{formatTestName(response)}</div>
              <div className="mt-2 text-lg">
                <strong>Sayı:</strong> {count}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="flex flex-column gap-3">
      <Card title="Anket Sonuçları" className="w-full">
        {/* <TabView>
          <TabPanel header="Hesaplama">
            <div className="flex flex-column gap-3">
              <Panel header="Soru">
                <div className="text-lg">
                  Kurumunuzda kullanılan araçların sayısı, alınan araç sayısı, faal ömrü ve pert miktarı nedir?
                </div>
              </Panel>
              <Panel header="İstatistikler">
                <div className="col-12">
                  <strong>Toplam Yanıt:</strong> {surveyResults?.result?.data.karbon_ayak_izi.total_responses}
                </div>
                <div className="grid">
                  <div className="col-12 md:col-6 lg:col-4 xl:col-3">
                    <div className="p-2 border-1 surface-border border-round">
                      <strong className="text-md font-bold text-primary">Ortalama Araç Sayısı:</strong>
                      <br />
                      {surveyResults?.result?.data.karbon_ayak_izi.avg_arac_sayisi.toFixed(2)}
                    </div>
                  </div>
                  <div className="col-12 md:col-6 lg:col-4 xl:col-3">
                    <div className="p-2 border-1 surface-border border-round">
                      <strong className="text-md font-bold text-primary">Ortalama Alınan Araç:</strong>
                      <br />
                      {surveyResults?.result?.data.karbon_ayak_izi.avg_arac_alinan.toFixed(2)}
                    </div>
                  </div>
                  <div className="col-12 md:col-6 lg:col-4 xl:col-3">
                    <div className="p-2 border-1 surface-border border-round">
                      <strong className="text-md font-bold text-primary">Ortalama Faal Ömür:</strong>
                      <br />
                      {surveyResults?.result?.data.karbon_ayak_izi.avg_faal_omur.toFixed(2)}
                    </div>
                  </div>
                  <div className="col-12 md:col-6 lg:col-4 xl:col-3">
                    <div className="p-2 border-1 surface-border border-round">
                      <strong className="text-md font-bold text-primary">Ortalama Yıllık Pert Miktarı:</strong>
                      <br />
                      {surveyResults?.result?.data.karbon_ayak_izi.avg_pert_miktari.toFixed(2)}
                    </div>
                  </div>
                </div>
              </Panel>

              <Panel header="Yanıtlar">
                <DataTable
                  value={surveyResults?.result?.data.karbon_ayak_izi.responses}
                  showGridlines
                  stripedRows
                  paginator
                  rows={10}
                  emptyMessage="Hiç Yanıt Yok"
                >
                  <Column field="user_name" header="Kullanıcı"></Column>
                  <Column field="user_osb" header="OSB"></Column>
                  <Column field="arac_sayisi" header="Araç Sayısı"></Column>
                  <Column field="arac_sayisi_alinan" header="Alınan Araç"></Column>
                  <Column field="arac_faal_omur" header="Faal Ömür"></Column>
                  <Column field="arac_pert_miktari" header="Pert Miktarı"></Column>
                  <Column field="created_at" header="Tarih"></Column>
                </DataTable>
              </Panel>
            </div>
          </TabPanel>
          <TabPanel header="Raporlama">
            <div className="flex flex-column gap-3">
              <Panel header="Soru">
                <div className="text-lg">
                  OSB bünyesinde etkili kararlar alabilmek için ihtiyaç duyduğunuz analiz alanları aşağıdakilerden
                  hangisidir?{" "}
                </div>
              </Panel>
              <Panel header="İstatistikler">
                <div className="grid">
                  <div className="col-12">
                    <strong>Toplam Yanıt:</strong> {surveyResults?.result?.data.raporlama.total_responses}
                  </div>
                  {surveyResults?.result?.data.raporlama.response_counts && (
                    <div className="col-12">
                      {renderResponseCounts(surveyResults?.result?.data.raporlama.response_counts)}
                    </div>
                  )}
                </div>
              </Panel>

              <Panel header="Yanıtlar">
                <DataTable
                  value={surveyResults?.result?.data.raporlama.responses}
                  showGridlines
                  stripedRows
                  paginator
                  rows={10}
                  emptyMessage="Hiç Yanıt Yok"
                >
                  <Column field="user_name" header="Kullanıcı"></Column>
                  <Column field="user_osb" header="OSB"></Column>
                  <Column
                    field="result1"
                    header="Cevap"
                    body={(rowData) => (
                      <div className="flex justify-content-center align-items-center p-0 m-0">
                        <div className="p-0 flex align-items-center">
                          <div className="px-5 py-1 bg-green-100 text-green-900 border-round font-medium">
                            {rowData.result1 === "karbon_ayak_izi"
                              ? "Karbon ayak izi"
                              : rowData.result1 === "su_ayak_izi"
                              ? "Su ayak izi"
                              : rowData.result1 === "urun_karbon_ayak"
                              ? "Ürün karbon ayak izi"
                              : rowData.result1 === "ekolojik_ayak_izi"
                              ? "Ekolojik ayak izi"
                              : `${rowData.result1}`}
                          </div>
                        </div>
                      </div>
                    )}
                  ></Column>
                  <Column field="created_at" header="Tarih"></Column>
                </DataTable>
              </Panel>
            </div>
          </TabPanel>

          <TabPanel header="Analiz">
            <div className="flex flex-column gap-3">
              <Panel header="Soru">
                <div className="text-lg">
                  OSB'leriniz içerisinde yer alan katılımcılarınız son 1 yıl içerisinde aşağıdaki sektör alanlarından
                  hangisinde daha çok büyüme göstermiştir? (3 sektör seçiniz){" "}
                </div>
              </Panel>
              <Panel header="İstatistikler">
                <div className="grid">
                  <div className="col-12">
                    <strong>Toplam Yanıt:</strong> {surveyResults?.result?.data.grafik.total_responses}
                  </div>
                  {surveyResults?.result?.data.grafik.response_counts && (
                    <div className="col-12">
                      {renderResponseCountsAnaliz(surveyResults?.result?.data.grafik.response_counts)}
                    </div>
                  )}
                </div>
              </Panel>

              <Panel header="Yanıtlar">
                <DataTable
                  value={surveyResults?.result?.data.grafik.responses}
                  showGridlines
                  stripedRows
                  paginator
                  rows={10}
                  emptyMessage="Hiç Yanıt Yok"
                >
                  <Column field="user_name" header="Kullanıcı"></Column>
                  <Column field="user_osb" header="OSB"></Column>
                  <Column field="result1" header="Cevap 1"></Column>
                  <Column field="result2" header="Cevap 2"></Column>
                  <Column field="result3" header="Cevap 3"></Column>
                  <Column field="created_at" header="Tarih"></Column>
                </DataTable>
              </Panel>
            </div>
          </TabPanel>

          <TabPanel header="Eğitim">
            <div className="flex flex-column gap-3">
              <Panel header="Soru">
                <div className="text-lg">Bu eğitim size ne kadar faydalı oldu?</div>
              </Panel>
              <Panel header="İstatistikler">
                <div className="grid">
                  <div className="col-12">
                    <strong>Toplam Yanıt:</strong> {surveyResults?.result?.data.egitim.total_responses}
                  </div>
                  {surveyResults?.result?.data.egitim.response_counts && (
                    <div className="col-12">
                      {renderResponseCounts(surveyResults?.result?.data.egitim.response_counts)}
                    </div>
                  )}
                </div>
              </Panel>

              <Panel header="Yanıtlar">
                <DataTable
                  value={surveyResults?.result?.data.egitim.responses}
                  showGridlines
                  stripedRows
                  paginator
                  rows={10}
                  emptyMessage="Hiç Yanıt Yok"
                >
                  <Column field="user_name" header="Kullanıcı"></Column>
                  <Column field="user_osb" header="OSB"></Column>
                  <Column field="result1" header="Cevap"></Column>
                  <Column
                    field="result1"
                    header="Cevap"
                    body={(rowData) => (
                      <div className="flex justify-content-center align-items-center p-0 m-0">
                        <div className="p-0 flex align-items-center">
                          {rowData.result1 === "cok_oldu" ? (
                            <div className="px-5 py-1 bg-green-100 text-green-900 border-round font-medium">
                              Çok Faydalı Oldu
                            </div>
                          ) : rowData.result1 === "olmadı" ? (
                            <div className="px-5 py-1 bg-red-100 text-red-900 border-round font-medium">
                            Faydalı Olmadı
                            </div>
                          ) : rowData.result1 === "biraz" ? (
                            <div className="px-5 py-1 bg-yellow-100 text-yellow-900 border-round font-medium">
                            Biraz Faydalı Oldu
                            </div>
                          ) : (
                            `${rowData.result1}`
                          )}
                        </div>
                      </div>
                    )}
                  ></Column>
                  <Column field="created_at" header="Tarih"></Column>
                </DataTable>
              </Panel>
            </div>
          </TabPanel>

          <TabPanel header="İş Sürekliliği">
            <div className="flex flex-column gap-3">
              <Panel header="Soru">
                <div className="text-lg">OSB’nizin afetlerde üretime devam etmesi için bir planınız var mı?</div>
              </Panel>
              <Panel header="İstatistikler">
                <div className="grid">
                  <div className="col-12">
                    <strong>Toplam Yanıt:</strong> {surveyResults?.result?.data.afad.total_responses}
                  </div>
                  {surveyResults?.result?.data.afad.response_counts && (
                    <div className="col-12">
                      {renderResponseCounts(surveyResults?.result?.data.afad.response_counts)}
                    </div>
                  )}
                </div>
              </Panel>

              <Panel header="Yanıtlar">
                <DataTable
                  value={surveyResults?.result?.data.afad.responses}
                  showGridlines
                  stripedRows
                  paginator
                  rows={10}
                  emptyMessage="Hiç Yanıt Yok"
                >
                  <Column field="user_name" header="Kullanıcı"></Column>
                  <Column field="user_osb" header="OSB"></Column>
                  <Column field="result1" header="Cevap"></Column>
                  <Column field="created_at" header="Tarih"></Column>
                </DataTable>
              </Panel>
            </div>
          </TabPanel>

          <TabPanel header="OSBÜK Bülten">
            <div className="flex flex-column gap-3">
              <Panel header="Soru">
                <div className="text-lg">Bültenimizde hangi konulara yer vermemizi istersiniz?</div>
              </Panel>
              <Panel header="İstatistikler">
                <div className="grid">
                  <div className="col-12">
                    <strong>Toplam Yanıt:</strong> {surveyResults?.result?.data.haber.total_responses}
                  </div>
                </div>
              </Panel>

              <Panel header="Yanıtlar">
                <DataTable
                  value={surveyResults?.result?.data.haber.responses}
                  showGridlines
                  stripedRows
                  paginator
                  rows={10}
                  emptyMessage="Hiç Yanıt Yok"
                >
                  <Column field="user_name" header="Kullanıcı"></Column>
                  <Column field="user_osb" header="OSB"></Column>
                  <Column field="result1" header="Cevap"></Column>
                  <Column field="created_at" header="Tarih"></Column>
                </DataTable>
              </Panel>
            </div>
          </TabPanel>
        </TabView> */}
      </Card>
    </div>
  );
};

export default SurveyResults;
